import React, { useEffect } from 'react';
import '../../assets/css/cart.css';
import { useDispatch, useSelector } from 'react-redux';
import { decrementQuantity, incrementQuantity, removeFromCart } from '../../Redux/Slices/cartSlice';
import { fa_currency, fa_number } from '../../utils/PersianNum';

export default function Cart({ onClose }) {
    const cart = useSelector((state) => state.cart.cart);
    const dispatch = useDispatch();

    // Calculate total price and total discount
    const totalPrice = cart.reduce((total, product) => {
        const discountedPrice = product.sale_price ? product.sale_price : product.price;
        return total + discountedPrice * product.quantity;
    }, 0);

    const totalDiscount = cart.reduce((total, product) => {
        const discountAmount = product.price - product.sale_price;
        return total + discountAmount * product.quantity;
    }, 0);

    const handleClickOutside = (event) => {
        const popupContent = document.querySelector('.popup-content');
        if (popupContent && !popupContent.contains(event.target)) {
        onClose();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='cart'>
        <div className="popup-container">
            <div className="popup-content">
                <div className='topbar'>
                    <h5 className='name text-light text-center mt-3'>Shopping Cart<span className="fa fa-cart-arrow-down mx-2"></span></h5>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>
                <div className="d-flex align-items-center flex-column" style={{height: "95vh"}}>
                    <div className="w-100 mb-auto p-2 mt-5 overflow-scroll shadow-sm">
                        {cart.length === 0 ? 
                            <p className='pt-3'>Your cart is empty!</p>
                        : 
                        cart.map((product) => (
                            <div className="d-flex align-items-center mb-2 border p-2" key={product.id}>
                                <div className="flex">
                                    <img src={product.images}
                                    className="img-fluid" style={{width: "100px"}} alt="Generic placeholder"/>
                                </div>
                                <div className="flex ms-3">
                                    <h6 className="text-primary mb-2">{product.name}</h6>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <p className='my-auto me-2'>Amount:</p>
                                        <div className="btn-group btn-group-sm" role="group" aria-label="Basic mixed styles example">
                                            <button type="button" onClick={() => dispatch(incrementQuantity(product.id))} className="btn btn-outline-success"><span className="fa fa-plus"></span></button>
                                            <button type="button" className="btn btn-outline-secondary">{fa_number(product.quantity)}</button>
                                            <button type="button" onClick={() => dispatch(decrementQuantity(product.id))}  className="btn btn-outline-danger"><span className="fa fa-minus"></span></button>
                                        </div>
                                        <button onClick={() => dispatch(removeFromCart(product.id))} className="btn ms-2"><i className="fa fa-trash text-danger"></i></button>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <p className='my-auto'>Price:</p>
                                        {product.sale_price && product.sale_price > 0 ?
                                            <p className="text-muted mb-0"><del>{fa_currency(+product.price)}</del> {fa_currency(+product.sale_price)}Toman</p>
                                            :
                                            <p className="text-muted mb-0">{fa_currency(+product.price)} Toman</p>
                                        }
                                    </div>

                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="w-100 p-2 pt-4 border-top border-2">
                        <div className="d-flex justify-content-between px-2">
                            <p className="fw-bold">Discount:</p>
                            <p className="fw-bold">{fa_currency(+totalDiscount)}</p>
                        </div>
                        <div className="d-flex justify-content-between p-2 mb-2 rounded" style={{backgroundColor: "#e1f5fe"}}>
                            <h5 className="fw-bold mb-0">Checkout Price:</h5>
                            <h5 className="fw-bold mb-0">{fa_currency(+totalPrice)}</h5>
                        </div>
                    </div>
                    <div className="w-100 p-2">
                        <div className="d-grid col mx-auto">
                            <button type="button" className="btn btn-lg btn-success">Checkout</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </div>
    );
};